import { switchMap } from 'rxjs';
import { fromFetch } from 'rxjs/fetch';
import { getCommunitiesResults } from 'constants/routes'

function getResults(payload) {
  const url = `${getCommunitiesResults}`;

  return fromFetch(url, {
    method: 'POST',
    body: JSON.stringify({
      searchCommand: {
        ...payload.searchParameters
      },
      selectedMarkerId: payload.selectedMarkerId
    }),
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'image/webp'
    }
  }).pipe(
    switchMap((response) => response.text())
  );
}

export default getResults;
